import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type { AuditLogsExpandedGridInterface } from '@src/domain/types/audit-logs.interface';
import { AuditLog, AuditLogLevels, AuditLogsResponse } from 'cmp-client-api';
import { AuditLogsAndCursorInterface } from '@src/domain/types';

const transformFromApiModel = (apiModel: AuditLogsResponse): AuditLogsAndCursorInterface => {
  const items: AuditLogsExpandedGridInterface[] = apiModel.data.map((item: AuditLog) => ({
    item: {
      user: item.user || '',
      tenantId: item.tenantId || '',
      type: item.subjectType || '',
      level: item.level || AuditLogLevels.Info,
      message: item.message || '',
      messageId: item.messageId || '',
      parameters: item.parameters,
      timestamp: item.timestamp ? new Date(item.timestamp) : null,
    },
    expanded: false,
  }));

  return {
    items,
    cursor: apiModel.cursor,
  };
};

export const AuditLogsMapper: MapperInterface<AuditLogsAndCursorInterface, AuditLogsResponse> = {
  transformFromApiModel,
};
